// packages/chatbot/src/utils/widget.ts

import { decodeJwtPayload } from './jwt';

/**
 * Extracts wid from a WAT (widget auth token) JWT payload.
 */
export function getWidFromWat(wat?: string | null): string | null {
  if (!wat) return null;
  const payload = decodeJwtPayload<{ wid?: string }>(wat);
  return payload?.wid || null;
}
